import * as React from 'react';
import { createComponent } from '@workday/canvas-kit-react/common';
import { Text } from '@workday/canvas-kit-react/text';
export const CardHeading = createComponent('h3')({
    displayName: 'Card.Heading',
    Component: ({ children, ...elemProps }, ref, Element) => {
        return (React.createElement(Text, Object.assign({ ref: ref, typeLevel: "body.large", fontWeight: "bold", marginBottom: "m", marginTop: 0, as: Element }, elemProps), children));
    },
});
